import { render, staticRenderFns } from "./DadosModelo.vue?vue&type=template&id=0b7f8b00&scoped=true&"
import script from "./DadosModelo.vue?vue&type=script&lang=ts&"
export * from "./DadosModelo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7f8b00",
  null
  
)

export default component.exports